import { useEffect, useState } from "react";
import firestoreService from "../../services/firestoreService";


const useLecutre = () => {

    const [lectureList, setLectureList] = useState([])
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        fetchLecure()
    }, [])

    const fetchLecure = async() => {
        const result = await firestoreService.getCollection(`Lecture`);
        if (result?.success && Array.isArray(result.data)) {
            setLectureList(result.data);
        }
        setLoaded(true);
    }

    return{
        lectureList,
        loaded
    }

}

export default useLecutre;